import styled from "styled-components";

import typography from "../../theme/typography";

const StyleButton = styled.button`
  ${typography.buttonText1};
  background-color: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.black};
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 80px;
  height: 80px;
  position: relative;
`;

const TextButton = ({ text, onClick }) => {
  return <StyleButton onClick={onClick}>{text}</StyleButton>;
};

export default TextButton;
